<template>
  <NuxtImg
    v-if="!$isMobile()"
    src="https://cdn-assets.boostingmarket.com/home_bg_image.webp"
    alt="Boostingmarket.com website background image sm-hide"
    class="main_layout_bg_home home_bg"
    loading="eager"
    fetchpriority="high"
    width="986"
    height="600"
    preload
  />

  <div class="d-flex-column justify-start align-start gap-10">
    <HomeHero />

    <div class="d-flex-row above-sm-hide">
      <p
        class="t-white above-sm-hide font-family-1 title-h1 f-w-600 select_game_text"
      >
        {{ $t("app.select_game_1") }}
        <span class="t-light-orange"> {{ $t("app.select_game_2") }}</span>
      </p>
    </div>
    <div
      class="games_list_container"
      style="min-height: 400px"
      v-if="!$isMobile()"
    >
      <LazyCardsHomeGameCard
        v-for="(game, index) in games"
        :key="game.id"
        :index="index"
        :title="game.title"
        :slug="game.slug"
        :logo-text="game.textLogo"
        :disabled="game?.disabled"
        :link="`/${game.slug}`"
        :has-new="game?.hasNew"
        :has-new-game="game?.hasNewGame"
        :preload="false"
      />
    </div>

    <div
      class="games_list_container"
      style="min-height: 400px"
      v-else-if="$isMobile() && hasScrolled"
    >
      <LazyCardsHomeGameCard
        v-for="(game, index) in games"
        :key="game.id"
        :index="index"
        :title="game.title"
        :slug="game.slug"
        :logo-text="game.textLogo"
        :disabled="game?.disabled"
        :link="`/${game.slug}`"
        :has-new="game?.hasNew"
        :has-new-game="game?.hasNewGame"
        :preload="false"
      />
    </div>

    <LazySectionsMobileBanner v-if="hasScrolled" />

    <LazySectionsWhyUs
      :items="items"
      :active-index="activeIndex"
      @set-index="setActiveIndex"
      v-if="hasScrolled"
    />
    <LazyBannersMembershipBanner v-if="hasScrolled" />
    <LazySectionsReviewsBanner v-if="hasScrolled" />
    <div class="faq-dummy"></div>
    <LazySectionsFaqSection v-if="hasScrolled" />
    <LazySectionsBlogSection v-if="hasScrolled" />
  </div>
</template>

<script setup>
import HomeHero from "~/components/banners/HomeHero.vue";

import { computed, ref, onMounted, onBeforeUnmount } from "vue";
const { nuxtEnv } = useRuntimeConfig();
const games = [
  {
    id: 26,
    title: "Clash Royale",
    slug: "clash-royale-boost",
    image: "/images/games/rematch-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/clash-royale-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/clash-royale-boost/game_icon.webp",
  },
  {
    id: 12,
    title: "World of Warcraft",
    slug: "world-of-warcraft-boost",
    image: "/images/games/world-of-warcraft-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/world-of-warcraft-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/world-of-warcraft-boost/game_icon.webp",
  },
  {
    id: 1,
    title: "League of Legends",
    slug: "league-of-legends-boost",
    image: "/images/games/league-of-legends-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/league-of-legends-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/league-of-legends-boost/game_icon.webp",
  },
  {
    id: 19,
    title: "Marvel Rivals",
    slug: "marvel-rivals-boost",
    image: "/images/games/marvel-rivals-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/marvel-rivals-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/marvel-rivals-boost/game_icon.webp",
    reqsDisabled: true,
  },
  {
    id: 3,
    title: "Rainbow Six Siege",
    slug: "rainbow-six-siege-boost",
    image: "/images/games/rainbow-six-siege-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/rainbow-six-siege-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/rainbow-six-siege-boost/game_icon.webp",
  },
  {
    id: 4,
    title: "Rocket League",
    slug: "rocket-league-boost",
    image: "/images/games/rocket-league-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/rocket-league-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/rocket-league-boost/game_icon.webp",
  },
  {
    id: 24,
    title: "FC25",
    slug: "fc-boost",
    image: "/images/games/fc-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/fc-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/fc-boost/game_icon.webp",
    hasNewGame: false,
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/fc-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/fc-boost/fc-boost-fut-champ-boost`,
        pack_id: 49,
      },
    ],
  },
  {
    id: 2,
    title: "Valorant",
    slug: "valorant-boost",
    image: "/images/games/valorant-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/valorant-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/valorant-boost/game_icon.webp",
  },
  {
    id: 7,
    title: "Counter Strike 2",
    slug: "counter-strike-2-boost",
    image: "/images/games/counter-strike-2-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/counter-strike-2-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/counter-strike-2-boost/game_icon.webp",
  },
  {
    id: 8,
    title: "Apex Legends",
    slug: "apex-legends-boost",
    image: "/images/games/apex-legends-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/apex-legends-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/apex-legends-boost/game_icon.webp",
  },
  {
    id: 6,
    title: "Overwatch 2",
    slug: "ow-boost",
    image: "/images/games/ow-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/ow-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/ow-boost/game_icon.webp",
  },
  {
    id: 5,
    title: "Dota 2",
    slug: "dota-2-boost",
    image: "/images/games/dota-2-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/dota-2-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/dota-2-boost/game_icon.webp",
  },

  {
    id: 10,
    title: "Fortnite",
    slug: "fortnite-boost",
    image: "/images/games/fortnite-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/fortnite-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/fortnite-boost/game_icon.webp",
    hasNew: false,
    disabled: false,
    hasNew: false,
    requirements: {
      allRegions: ["Champion / Unreal"],
    },
  },
  {
    id: 9,
    title: "Teamfight Tactics",
    slug: "teamfight-tactics-boost",
    image: "/images/games/teamfight-tactics-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/teamfight-tactics-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/teamfight-tactics-boost/game_icon.webp",
  },
  {
    id: 17,
    title: "Call of Duty",
    slug: "call-of-duty-boost",
    // image: "/images/games/call-of-duty-boost/home_image.webp",
    image: "",
    textLogo: "",
    // textLogo: "https://cdn-assets.boostingmarket.com/games/call-of-duty-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/call-of-duty-boost/game_icon.webp",
    reqsDisabled: true,
    // hasNew: true,
  },
  {
    id: 22,
    title: "Path of Exile II",
    slug: "path-of-exile-2-boost",
    image: "/images/games/path-of-exile-2-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/path-of-exile-2-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/path-of-exile-2-boost/game_icon.webp",
    reqsDisabled: true,
    hasNewGame: false,
  },
  {
    id: 25,
    title: "Rematch",
    slug: "rematch-boost",
    image: "/images/games/rematch-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/rematch-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/rematch-boost/game_icon.webp",
  },

  {
    id: 16,
    title: "The Finals",
    slug: "the-finals-boost",
    image: "/images/games/the-finals-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/the-finals-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/the-finals-boost/game_icon.webp",
  },

  {
    id: 21,
    title: "Grand Theft Auto 6",
    slug: "gta-6-boost",
    image: "/images/games/gta-6-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/gta-6-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/gta-6-boost/game_icon.webp",
    disabled: false,
    reqsDisabled: true,
  },
  {
    id: 16,
    title: "Destiny 2",
    slug: "destiny-2-boost",
    image: "/images/games/destiny-2-boost/home_image.webp",
    textLogo:
      "https://cdn-assets.boostingmarket.com/games/destiny-2-boost/text_logo.webp",
    icon: "https://cdn-assets.boostingmarket.com/games/destiny-2-boost/game_icon.webp",
    disabled: true,
    reqsDisabled: true,
  },
];
definePageMeta({
  layout: "default",
  pageInfo: {
    name: "home",
  },
});

// HOOKS
const { t } = useI18n();
const { getUtm } = useUserStore();
const router = useRouter();
const route = router.currentRoute;
const localePath = useLocalePath();
const hasScrolled = ref(false);
const items = computed(() => {
  return [
    {
      title: t("homepage.why_us.first.title"),
      image: "https://cdn-assets.boostingmarket.com/why_us/first.webp",
      placeholder:
        "https://cdn-assets.boostingmarket.com/why_us/first_placeholder.webp",
      description: t("homepage.why_us.first.description"),
    },
    {
      title: t("homepage.why_us.second.title"),
      image: "https://cdn-assets.boostingmarket.com/why_us/second.webp",
      placeholder:
        "https://cdn-assets.boostingmarket.com/why_us/second_placeholder.webp",
      description: t("homepage.why_us.second.description"),
    },
    {
      title: t("homepage.why_us.third.title"),
      image: "https://cdn-assets.boostingmarket.com/why_us/third.webp",
      placeholder:
        "https://cdn-assets.boostingmarket.com/why_us/third_placeholder.webp",
      description: t("homepage.why_us.third.description"),
    },
    {
      title: t("homepage.why_us.fourth.title"),
      image: "https://cdn-assets.boostingmarket.com/why_us/fourth.webp",
      placeholder:
        "https://cdn-assets.boostingmarket.com/why_us/fourth_placeholder.webp",
      description: t("homepage.why_us.fourth.description"),
    },
  ];
});

const activeIndex = ref(0);
const toggleScroll = () => {
  hasScrolled.value = !hasScrolled.value;
  window.removeEventListener("scroll", toggleScroll);
};

// METHODS
const setActiveIndex = (index = 1) => {
  activeIndex.value = index;
};
addCanonicalLink(route.value.fullPath);

onNuxtReady(() => {
  window.addEventListener("scroll", toggleScroll);
  const utmDataSet = getUtm;

  if (nuxtEnv === "prod") {
    window?.analytics?.page("Main Page", {
      ...utmDataSet,
    });
  }
});
onMounted(() => {
  if (route.value.query?.to) {
    setTimeout(() => {
      const el = document.querySelector(`#${route.value.query?.to}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        router.replace(localePath("/"));
      } else {
        const el2 = document.querySelector(`.faq-dummy`);
        el2.scrollIntoView({ behavior: "smooth", block: "end" });
        window.onscrollend = () => {
          const el3 = document.querySelector(`#${route.value.query?.to}`);
          el3.scrollIntoView({ behavior: "smooth" });
          router.replace(localePath("/"));
        };
        // el3.scrollIntoView({ behavior: "smooth" });
      }
    }, 500);
  }
});

useSeoMeta({
  title: t("main.meta.title"),
  description: t("main.meta.description"),
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", toggleScroll);
});
</script>
